import { Team } from "./team";
import { Athlete } from "./athlete";

interface GuestData {
  id?: number;
  userId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  rights?: string[];

  athletes?: Athlete[];
  teams?: Team[];
}


export class Guest {
  public static getNonTranslatableFields(): string[] { return ['id', 'userId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'userId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  userId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  rights?: string[];

  athletes?: Athlete[];
  teams?: Team[];

  public static fromAPI(data: GuestData): Guest {
    if (data.athletes) {
      data.athletes = Athlete.fromAPIList(data.athletes);
    }
    if (data.teams) {
      data.teams = Team.fromAPIList(data.teams);
    }
    return new Guest(data);
  }

  public static fromAPIList(data: GuestData[]): Guest[] {
    return data.map((item: GuestData) => Guest.fromAPI(item));
  }

  constructor({id, userId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId, rights, athletes, teams}: GuestData) {
    this.id = id;
    this.userId = userId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
    this.rights = rights;
    this.athletes = athletes;
    this.teams = teams;
  }

  public toJson(): Object {
    return {
      id: this.id,
      userId: this.userId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
